import React, { useEffect, useState } from "react";
import axios from "axios";
import { Input } from "reactstrap";

const CompanySelector = ({ onCompanyChange, onCompaniesLoaded, selectedCompanyId, showAllOption = false }) => {
  const [companies, setCompanies] = useState([]);
  const [companyId, setCompanyId] = useState("");

  // Load initial company
  useEffect(() => {
    const userInfos = JSON.parse(sessionStorage.getItem("atsuser-info"));
    const defaultId = userInfos?.user_details?.companies_data?.[0]?.company_id;

    if (selectedCompanyId) {
      setCompanyId(selectedCompanyId);
    } else if (defaultId) {
      setCompanyId(defaultId);
      const initialCompany = userInfos.user_details.companies_data[0];
      onCompanyChange?.(initialCompany);
    }
  }, [selectedCompanyId]);

  const getCompanyDetails = async () => {
    if (!companyId) return;
    try {
      const response = await axios.get(`api/v1/companyv1?company_id=${companyId}`);
      const response_data = response.data;

      if (response_data?.message) {
        let list = response_data.message;

        // ⭐ Add "All" option if enabled — keep uppercase "All"
        if (showAllOption) {
          list = [
            { company_id: "All", company_domain: "All" },
            ...list
          ];
        }

        setCompanies(list);
        onCompaniesLoaded?.(list);
      }
    } catch (error) {
      console.error("Error fetching company details:", error);
    }
  };

  useEffect(() => {
    getCompanyDetails();
  }, [companyId]);

  const handleCompanyChange = e => {
    const selectedValue = e.target.value;

    // 🔥 Handle ALL (use "All" consistently)
    if (selectedValue === "All") {
      setCompanyId("All");
      onCompanyChange?.({ company_id: "All" });
      return;
    }

    const selectedId = Number(selectedValue);
    setCompanyId(selectedId);

    const selectedCompany = companies.find(c => c.company_id === selectedId);
    onCompanyChange?.(selectedCompany);
  };

  return (
    <Input
      className="mb-3"
      type="select"
      value={companyId || ""}
      onChange={handleCompanyChange}
    >
      {companies.map(company => (
        <option key={company.company_id} value={company.company_id}>
          {company.company_domain}
        </option>
      ))}
    </Input>
  );
};

export default CompanySelector;
